import styled from "styled-components";

import { Button } from "@similarweb/ui-components";

export const StyledFiltersPanelClearButton = styled(Button)`
    align-self: center;
    padding: 8px 10px;
    min-width: auto;

    & > div {
        font-size: 12px;
        line-height: 20px;
        text-transform: capitalize;
    }
`;
